import {Feature} from "geojson";

export enum GEO_TYPES {
    Point = 'Point',
    Polygon = 'Polygon',
    MultiPolygon = 'MultiPolygon',
    LineString = 'LineString'
}

export function getGeoType (feature: Feature) {
    try {
        const type = feature.geometry ?
            feature.geometry.type :
            feature.properties ? feature.properties.geoType : '';
        switch (type) {
            case GEO_TYPES.Point:
                return 'Point';
            case GEO_TYPES.LineString:
                return 'Line';
            case GEO_TYPES.MultiPolygon:
            default:
                return 'Polygon';

        }
    } catch (e) {
        console.warn('failed to get type for feature', feature);
    }
    return 'Polygon';
}